import { AppConstants } from "../../../app.constants";
import { TimerType } from "../../enums/timer-type.enum";

export class TimerConfig {
  Id: number;
  PlaylistItemId: number;
  ShowSeconds: boolean;
  TimerInterval: string;
  TimerType: TimerType;
  PositionX: number;
  PositionY: number;
  Width: number;
  Height: number;
  TextColor: string;
  BackgroundColor: string;

  constructor() {
    this.TimerInterval = AppConstants.DEFAULT_PLAYLIST_ITEM_DURATION;
    this.TimerType = TimerType.Clock;
    this.Width = AppConstants.TIMER_DEFAULT_WIDTH;
    this.Height = AppConstants.TIMER_DEFAULT_WIDTH;
    this.PositionX = AppConstants.TIMER_DEFAULT_POSITION;
    this.PositionY = AppConstants.TIMER_DEFAULT_POSITION;
    this.TextColor = AppConstants.TIMER_DEFAULT_TEXT_COLOR;
    this.BackgroundColor = AppConstants.TIMER_DEFAULT_BACKGROUND_COLOR;
  }
}
